import type { LimitationDefinition, LimitationOption } from "src/shared/api-types/limitations";

import { limitationTemplates } from "./limitationTemplates";

type Translate = (key: string, options?: { defaultValue?: string }) => string;

export const getBooleanDisplayValue = (value: boolean, t: Translate): string => (value ? t("yes") : t("no"));

export const getDefinitionDisplayName = (
  definition: Pick<LimitationDefinition, "code" | "name">,
  t: Translate,
): string => {
  const template = limitationTemplates.find((item) => item.code === definition.code && item.key !== "custom");
  if (!template) return definition.name;
  if (definition.name !== template.name) return definition.name;

  const translationKey = `limitations.templates.${template.key}`;
  const translatedName = t(translationKey, { defaultValue: definition.name });
  return translatedName === translationKey ? definition.name : translatedName;
};

export const getLimitationValueDisplayValue = (
  type: LimitationDefinition["type"],
  value: LimitationOption["value"],
  t: Translate,
): string => {
  if (type === "boolean") return getBooleanDisplayValue(value === true || value === "true", t);
  return String(value);
};

export const getLimitationPreviewValues = (
  type: LimitationDefinition["type"],
  values: Array<LimitationOption["value"]>,
  t: Translate,
): string[] => {
  if (type === "boolean") return [t("yes"), t("no")];
  return values.map((value) => getLimitationValueDisplayValue(type, value, t));
};

export const getOptionDisplayValue = (
  definition: LimitationDefinition,
  option: LimitationOption,
  t: Translate,
): string => {
  if (definition.type === "list") return String(option.value);
  if (definition.type === "boolean") return getLimitationValueDisplayValue(definition.type, option.value, t);
  const operator = definition.operator ? `${definition.operator} ` : "";
  const unit = definition.unit ?? "";
  return `${operator}${getLimitationValueDisplayValue(definition.type, option.value, t)}${unit}`.trim();
};
